export const mainContentId = "main-content";

export const windowRootId = "window-root";
